<template>
    <div>
        <TableList
            :form_data_seo.sync="form_data_seo"
            :columns="columns"
            :get_table_list="this.get_table_list"
            :slot_table_list="['user_num','customer_num','status','operation']"
            ref="list"
			:is_created_get_list="true"
            :submit_preprocessing="submit_preprocessing"
            rowKey="id"
        >
            <template slot="form_after">
				<div class="page_content">
					<a-row type="flex">
						<a-col style="flex:1" v-for="item in visitInfo" :key="item.label">
							<a-statistic :title="item.label" :value="item.value"></a-statistic>
						</a-col>
					</a-row>
				</div>
			</template>

			<template slot="left_btn">
				<a-button class="a_btn ant-btn-primary" style='padding:0 15px;margin-left:0;' @click="getSave">新增规则</a-button>
                <a-button class="a_btn ant-btn-primary" style='padding:0 15px;' @click="getAllVisitSet">全局设置</a-button>
            </template>

            <template slot="user_num" slot-scope="data">
                <span class="op_text" @click="getRuleUser(data.record)">{{data.record.user_num}}</span>
            </template>
            <template slot="customer_num" slot-scope="data">
                <span class="op_text" @click="getCustomerUser(data.record)">{{data.record.customer_num}}</span>
            </template>
            <template slot="status" slot-scope="data">
                <a-switch @change='changeStatus(data.record)' v-model:checked="data.record.status == 1 ? true : false" />
            </template>
            <template slot="operation" slot-scope="data">
                <a v-auth="'change'" @click="getSave(data.record)">编辑</a>
                <a-divider type="vertical" v-auth="'change'" />
                <a v-auth="'change'" @click="getDel(data.record)">删除</a>
            </template>
        </TableList>

        <a-modal title="全局设置" :visible="visitSetVisible" :width="'450px'"  @ok="getVisitSetSubmit" @cancel="visitSetVisible = false" >
			<a-form-model-item >
				<div>
					<span class="label">全局拜访时间（分钟）:</span>
					<a-input v-model:value="visitTimes" placeholder="请输入全局拜访时间" type="number"/>
				</div>
			</a-form-model-item>
		</a-modal>

        <a-modal title="适用人员" :footer="null" v-if="ruleUserVisible" :visible="true" :width="'900px'" @cancel="ruleUserVisible = false" >
			<ruleUser :ruleDepartmentData="ruleDepartmentData" :ruleRoleData="ruleRoleData"></ruleUser>
		</a-modal>

        <a-modal title="适用客户" :footer="null" v-if="ruleCustomerVisible" :visible="true" :width="'900px'" @cancel="ruleCustomerVisible = false" >
			<ruleCustomer :ruleCustomerData="ruleCustomerData"></ruleCustomer>
		</a-modal>

    </div>
</template>

<script>
    import { Modal,message } from 'ant-design-vue'
    import TableList from "@/components/TableList";
    import ruleUser from './components/ruleUser.vue'
    import ruleCustomer from './components/ruleCustomer.vue'

    import { 
        getVisitConfigList, 
        getVisitConfig,
        saveWholeVisitConfig,
        changeVisitConfigStatus,
        delVisitConfig,
		//getTypeSelect
    } from "@/api/visitSet";

    const columns = [
        {
            title: "规则名称",
            dataIndex: "name",
        },
		{
		    title: "拜访类型",
		    dataIndex: "type_name",
		},
        {
            title: "适用人员数",
            dataIndex: "user_num",
            scopedSlots: {
                customRender: "user_num"
            }
        },
        {
            title: "适用客户数",
            dataIndex: "customer_num",
            scopedSlots: {
                customRender: "customer_num"
            }
        },
        {
            title: "拜访时间（分钟）",
            dataIndex: "visit_times",
        },
        {
            title: "排序号",
            dataIndex: "sort",
        },
        {
            title: "状态",
            dataIndex: "status",
            scopedSlots: {
                customRender: "status"
            }
        },
        {
            title: "创建时间",
            dataIndex: "create_time",
        },
        
        {
            title: "更新时间",
            dataIndex: "update_time",
        },
        {
            title: "操作",
            scopedSlots: {
                customRender: "operation"
            }
        },
    ];

    export default {
        name: "Index",
        components: {
            TableList,
            ruleUser,
            ruleCustomer
        },
        data() {
            return {
                get_table_list:getVisitConfigList,
                submit_preprocessing: {
                    array_to_string: []
                },
                columns,
                form_data_seo: {
                    list: [
                        {
                            type: "text",
                            name: "keyword",
                            title: "名称",
                            placeholder: '规则名称',
                            options: {

                            }
                        },
						// {
						//     type: "select",
						//     name: "type",
						//     title: "拜访类型",
						//     mode: "default",
						//     options: {},
						//     list: [ ]
						// },
                        {
                            type: "select",
                            name: "status",
                            title: "状态",
                            mode: "default",
                            options: {},
                            list: [{
                                    key: "1",
                                    value: "启用"
                                },
                                {
                                    key: "-1",
                                    value: "禁用"
                                },
                            ]
                        },
                        {
                            type: "range_date",
                            name: "range_date",
                            title: "创建时间",
                            options: {},
                            start: {
                                name: 'start_time'
                            },
                            end: {
                                name: 'end_time'
                            },
                        },
                    ],
                    ...this.$config.form_data_seo
                },
                visitInfo:[],

                visitSetVisible:false,
                visitTimes:'',

                ruleUserVisible:false,
                ruleDepartmentData:'',
                ruleRoleData:'',

                ruleCustomerVisible:false,
                ruleCustomerData:'',
            }
        },
        async created() {
            this.$nextTick(()=>{
                this.getVisitConfigData()
		    })
			// getTypeSelect().then(res=>{
			// 	this.form_data_seo.list.forEach(item => {
			// 	    if (item.name == "type") {
			// 	        item.list = res.data.list.map(it=>{
			// 			return {
			// 				key: it.value,
			// 				value: it.label
			// 			}
			// 			});
			// 	    }
			// 	});
			// })
        },
        methods: {
            getVisitConfigData(){
                getVisitConfig().then(res=>{
                    this.visitInfo = res.data.list
                    this.visitTimes = res.data.visit_times
                })
            },

            getAllVisitSet(){
                this.visitSetVisible = true
            },
            getVisitSetSubmit(){
                saveWholeVisitConfig({
                    data:{
                        visit_times:this.visitTimes
                    }
                }).then(res=>{
                    this.visitSetVisible = false
                    this.getVisitConfigData()
                })
            },
            changeStatus(data){
                let statusText = data.status == 1 ? '禁用' : '启用'
                statusText = '确定要'+statusText+'【'+data.name+'】的拜访规则吗？'
                Modal.confirm({
                    title: '温馨提示',
                    content: statusText,
                    okText: '确认',
                    onOk() {
                        changeVisitConfigStatus({
                            data:{
                                id:data.id,
                                status:data.status == 1 ? '-1' : '1'
                            }
                        }).then(res=>{
                            data.status = data.status == 1 ? false : true
                            if(res.info)message.success(res.info);
                        })
                    }
                });
            },
            getDel(data){
                let that = this
                Modal.confirm({
                    title: '温馨提示',
                    content: '确定要删除【'+data.name+'】的拜访规则吗？',
                    okText: '确认',
                    onOk() {
                        delVisitConfig({
                            data:{
                                id:data.id
                            }
                        }).then(res=>{
                            that.getVisitConfigData()
					        that.$refs.list.get_list();
                        })
                    }
                });
            },
            getSave(data){
                this.$router.push({
					path: 'visitSave',
					query: {
						id: data.id ? data.id : ''
					}
				})
            },
            getRuleUser(data){
                this.ruleDepartmentData = data.department_ids
                this.ruleRoleData = data.role_ids
                this.ruleUserVisible = true
            },
            getCustomerUser(data){
                this.ruleCustomerData = data.group_ids
                this.ruleCustomerVisible = true
            },
            getEditSort(e,data){
                console.log(e.target)
                console.log(data)
            },
        }
    }
</script>

<style lang="less" scoped>
    .page_content{
        background: #fff;
        padding: 15px;
        margin: 15px;
    }

    .op_text{
        color:#397dee;
        cursor: pointer;
    }
</style>